import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { GlobalDependencies$reflection } from "../../Global.js";
import { Page$reflection } from "./Model.js";
import { record_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { FunctionComponent_Of_Z5A158BBF } from "../../fable_modules/Fable.React.7.4.3/Fable.React.FunctionComponent.fs.js";
import { RouterModule_urlSegments, RouterModule_encodeParts } from "../../fable_modules/Feliz.Router.3.8.0/Router.fs.js";
import { singleton, append } from "../../fable_modules/fable-library.3.7.20/List.js";
import * as react from "react";
import { FileImportProps, view as view_1 } from "../FileImport/View.js";
import { uncurry } from "../../fable_modules/fable-library.3.7.20/Util.js";

export class ImportsProps extends Record {
    constructor(GlobalDependencies, CurrentImportPage) {
        super();
        this.GlobalDependencies = GlobalDependencies;
        this.CurrentImportPage = CurrentImportPage;
    }
}

export function ImportsProps$reflection() {
    return record_type("Containers.Imports.View.ImportsProps", [], ImportsProps, () => [["GlobalDependencies", GlobalDependencies$reflection()], ["CurrentImportPage", Page$reflection()]]);
}

export const view = FunctionComponent_Of_Z5A158BBF((props) => {
    let children_2;
    const importProgramHref = RouterModule_encodeParts(append(RouterModule_urlSegments(window.location.hash, 1), singleton("FileImport")), 1);
    const matchValue = props.CurrentImportPage;
    switch (matchValue.tag) {
        case 2: {
            const children_8 = [react.createElement("h2", {}, "Not found")];
            return react.createElement("div", {}, ...children_8);
        }
        case 1: {
            return view_1(new FileImportProps(props.GlobalDependencies, matchValue.fields[0]));
        }
        default: {
            const children_4 = [(children_2 = [react.createElement("a", {
                href: importProgramHref,
            }, "FileImport")], react.createElement("h2", {}, ...children_2))];
            return react.createElement("div", {}, ...children_4);
        }
    }
}, "Bulk Import", uncurry(2, void 0), void 0, "view", "E:\\w\\1835\\s\\FenixWebApp\\fable\\src\\Containers\\Imports\\View.fs", 21);

